import sanitizeHtml from 'sanitize-html';

export const sanitizeContent = (content: string) =>
  sanitizeHtml(content, {
    allowedTags: [
      ...sanitizeHtml.defaults.allowedTags,
      'img',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'a',
      'b',
      'strong',
      'iframe',
    ],
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      img: ['src', 'alt'],
      a: ['href', 'target', 'rel', 'id'],
      h2: ['id'],
      h3: ['id'],
      h4: ['id'],
      h5: ['id'],
      p: ['id'],
      iframe: [
        'src',
        'width',
        'height',
        'frameborder',
        'allowfullscreen',
        'title',
        'picture-in-picture',
        'web-share',
        'encrypted-media',
        'autoplay',
        'data-src',
      ],
    },
    allowedSchemes: [
      ...sanitizeHtml.defaults.allowedSchemes,
      'data',
      'http',
      'https',
    ],
  }).replaceAll('data-src', 'src');
